// Portado de src/components/tratamento/CardsCapa.astro (site Astro).
export interface CardsCapaCard {
  img: string;
  srcSet?: string;
  badge: string;
  titulo: string;
  texto: string;
  href?: string;
}

export interface CardsCapaProps {
  sobretitulo: string;
  titulo: string;
  chamada?: string;
  cards: CardsCapaCard[];
  fundo?: "branco" | "areia";
}

export function CardsCapa({ sobretitulo, titulo, chamada, cards, fundo = "branco" }: CardsCapaProps) {
  return (
    <section className={`capas ${fundo}`}>
      <div className="container">
        <p className="sobretitulo">{sobretitulo}</p>
        <h2>{titulo}</h2>
        {chamada && <p className="capas-chamada">{chamada}</p>}
        <ul className="capas-grade">
          {cards.map((c) => {
            const conteudo = (
              <>
                <img
                  src={c.img.replace(/\.(png|jpg|jpeg)$/i, ".webp")}
                  {...(c.srcSet ? { srcSet: c.srcSet, sizes: "(min-width: 1000px) 33vw, (min-width: 700px) 50vw, 92vw" } : {})}
                  alt={c.titulo}
                  width={420}
                  height={500}
                  loading="lazy"
                />
                <span className="capa-veu" aria-hidden="true" />
                <span className="capa-topo">
                  <span className="capa-badge">{c.badge}</span>
                  {c.href ? <span className="capa-mais" aria-hidden="true">+</span> : null}
                </span>
                <span className="capa-base">
                  <span className="capa-titulo">{c.titulo}</span>
                  <span className="capa-texto">{c.texto}</span>
                </span>
              </>
            );
            return (
              <li key={c.titulo}>
                {c.href ? (
                  <a className="capa" href={c.href}>{conteudo}</a>
                ) : (
                  <div className="capa capa-indisponivel">{conteudo}</div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
